export default __webpack_public_path__ + "static/media/wrong.effa3ad1.mp3";